import React, { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import { Col, Heading, Row } from 'idsk-react-components';
import './vyhlasenieOPristupnosti.scss';

interface Props {
  text: string | null | undefined
}

const VyhlasenieOPristupnosti = (
  { text }
    : Props,
): ReactElement => (
  <div className="vyhlasenie">
    <Heading size="xl">Vyhlásenie o prístupnosti</Heading>
    {text && (
      <Row className="vyhlasenie-main__row">
        <Col className="vyhlasenie-main__col" width="two-thirds">
          <>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
          </>
        </Col>
      </Row>
    )}
  </div>

);

export default VyhlasenieOPristupnosti;
